export default __webpack_public_path__ + "static/InfoSection2-9811dda02a2a6412856267bdf3a2826e.png";